import { PropertyType as PropertyTypeEnum } from '@/entities/room'
import { useMultiScrollState } from '@/shared/lib'

import { PropertyTypesInDefaultView } from './default'
import { PropertyTypesInDialogView } from './dialog'
import { Filter, FilterType, useFilter } from '../../../model/filter'

export const PropertyTypes = () => {
  const { target, registerScrollElement, scrollIntoView } =
    useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { propertyTypes },
    updateFilter,
  } = useFilter()

  const isSelected = (value: PropertyTypeEnum) => propertyTypes.includes(value)

  const propertyTypesRef = (element: HTMLDivElement) => {
    if (element) {
      registerScrollElement(Filter.PropertyTypes, element)
    }
  }

  const handlePropertyTypeChange = (value: PropertyTypeEnum) => {
    updateFilter({ propertyTypes: value })
  }

  const handleExpandButtonClick = () => {
    requestAnimationFrame(() => {
      scrollIntoView(Filter.PropertyTypes, {
        behavior: 'smooth',
        block: 'start',
      })
    })
  }

  if (type === FilterType.Dialog) {
    return (
      <PropertyTypesInDialogView
        ref={propertyTypesRef}
        type={type}
        defaultExpanded={target === Filter.PropertyTypes}
        selected={isSelected}
        onExpand={handleExpandButtonClick}
        onChange={handlePropertyTypeChange}
      />
    )
  }

  return (
    <PropertyTypesInDefaultView
      ref={propertyTypesRef}
      type={type}
      selected={isSelected}
      onChange={handlePropertyTypeChange}
      className="pr-2" // 줄바꿈되는 현상 방지 위해 여백 추가
    />
  )
}
